export default __webpack_public_path__ + "static/media/gateway.bb17114f.png";